export default __webpack_public_path__ + "assets/whistle.png";